import Service = require("VSS/Service");
import Ajax = require("VSS/Ajax");
import { hasHeaderThrottlingMarkings } from "Dashboards.Web/ms.vss-dashboards.dashboards-rate-limiter/hasHeaderThrottlingMarkings";
import { IThrottleOnHighResourceUsage, HighResourceUsageInformation } from "Dashboards.Web/ms.vss-dashboards.dashboards-rate-limiter/IThrottleHighResourceUsage";



/** Responsible for Attaching to Legacy Platform Ajax client to listen for high resource usage and pass throttling signals as appropriate. */
export class LegacyRateLimitMonitorService extends Service.VssService {
    private _listenerInstance: IVssAjaxEventListener;
    private _throttlingRecipient: (usageInformation:HighResourceUsageInformation) => void;

    constructor() {
        super();

        this._throttlingRecipient = null;
        this._listenerInstance = {
            beforeRequest: this.beforeRequest.bind(this),
            responseReceived: this.responseReceived.bind(this),
            postResponseCallback: this.postResponseCallback.bind(this)
        };
    }

    public startListening(throttlingRecipient: IThrottleOnHighResourceUsage): void {
        if (throttlingRecipient == null || throttlingRecipient.flagAsThrottled == null) {
            throw new Error("A Throttling recipient must be provided.");
        }
        this._throttlingRecipient = throttlingRecipient.flagAsThrottled;
        Ajax.addGlobalListener(this._listenerInstance);
    }

    public stopListening(): void {
        if (this._throttlingRecipient == null) {
            throw new Error("No throttling recipient is currently registered");
        }

        this._throttlingRecipient = null;
        Ajax.removeGlobalListener(this._listenerInstance);
    }

    public beforeRequest?(requestId: number, requestUrl: string, ajaxOptions: JQueryAjaxSettings, vssRequestOptions: IVssAjaxOptions): void { }

    /**
    * Method invoked when a response has been received
    *
    * @param requestId A unique id that can be used to track this particular request (id is unique among all clients)
    * @param data The response data
    * @param textStatus A string indicating status of the request
    * @param jqXHR: The jQuery XHR object for the request
    * @param vssRequestOptions Additional VSS-specific options supplied in the request
    */
    public responseReceived(requestId: number, data: any, textStatus: string, jqXHR: JQueryXHR, vssRequestOptions: IVssAjaxOptions): void {
        if (hasHeaderThrottlingMarkings(jqXHR.getResponseHeader) && this._throttlingRecipient) {
            this._throttlingRecipient({
                listenerImplementationName: "LegacyRateLimitMonitorService",
                originatingUri: jqXHR.responseURL //Note: Request URI isn't available from jqXHR
            });
        }
    }

    public postResponseCallback?(requestId: number, data: any, textStatus: string, jqXHR: JQueryXHR, vssRequestOptions: IVssAjaxOptions): void { }
}
